// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/flow_template.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArchiveFlowTemplateRequest, ArchiveFlowTemplateResponse, CreateFlowTemplateRequest, CreateFlowTemplateResponse, GetFlowTemplateRequest, GetFlowTemplateResponse, GetFlowTemplateVersionRequest, GetFlowTemplateVersionResponse, InstantiateFlowTemplateRequest, InstantiateFlowTemplateResponse, ListFlowTemplatesRequest, ListFlowTemplatesResponse, ListFlowTemplateVersionsRequest, ListFlowTemplateVersionsResponse, RestoreFlowTemplateVersionRequest, RestoreFlowTemplateVersionResponse, UpdateFlowTemplateRequest, UpdateFlowTemplateResponse, ValidateFlowTemplateRequest, ValidateFlowTemplateResponse } from "./flow_template_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.FlowTemplateService
 */
export const FlowTemplateService = {
  typeName: "tracker.v1.FlowTemplateService",
  methods: {
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.ListFlowTemplates
     */
    listFlowTemplates: {
      name: "ListFlowTemplates",
      I: ListFlowTemplatesRequest,
      O: ListFlowTemplatesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.GetFlowTemplate
     */
    getFlowTemplate: {
      name: "GetFlowTemplate",
      I: GetFlowTemplateRequest,
      O: GetFlowTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.CreateFlowTemplate
     */
    createFlowTemplate: {
      name: "CreateFlowTemplate",
      I: CreateFlowTemplateRequest,
      O: CreateFlowTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.UpdateFlowTemplate
     */
    updateFlowTemplate: {
      name: "UpdateFlowTemplate",
      I: UpdateFlowTemplateRequest,
      O: UpdateFlowTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.InstantiateFlowTemplate
     */
    instantiateFlowTemplate: {
      name: "InstantiateFlowTemplate",
      I: InstantiateFlowTemplateRequest,
      O: InstantiateFlowTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.ValidateFlowTemplate
     */
    validateFlowTemplate: {
      name: "ValidateFlowTemplate",
      I: ValidateFlowTemplateRequest,
      O: ValidateFlowTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.ArchiveFlowTemplate
     */
    archiveFlowTemplate: {
      name: "ArchiveFlowTemplate",
      I: ArchiveFlowTemplateRequest,
      O: ArchiveFlowTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Version history.
     *
     * @generated from rpc tracker.v1.FlowTemplateService.ListFlowTemplateVersions
     */
    listFlowTemplateVersions: {
      name: "ListFlowTemplateVersions",
      I: ListFlowTemplateVersionsRequest,
      O: ListFlowTemplateVersionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.GetFlowTemplateVersion
     */
    getFlowTemplateVersion: {
      name: "GetFlowTemplateVersion",
      I: GetFlowTemplateVersionRequest,
      O: GetFlowTemplateVersionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowTemplateService.RestoreFlowTemplateVersion
     */
    restoreFlowTemplateVersion: {
      name: "RestoreFlowTemplateVersion",
      I: RestoreFlowTemplateVersionRequest,
      O: RestoreFlowTemplateVersionResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

